export default class SearchParams {
    static readonly lang = 'lang';
    static readonly plan = 'plan';
    static readonly utmSource = 'utm_source';
    static readonly utmMedium = 'utm_medium';
    static readonly utmCampaign = 'utm_campaign';
    static readonly referrer = 'referrer';
    static readonly outlookTypes = 'outlookTypes';
    static readonly isAzureLogin = 'isAzureLogin';
}